import type { ReactNode } from 'react';

export const symbol_format_paint_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M501.5-703.63Q493-712.25 493-725v-55H266l-40-40q15-10 32.5-15t36.5-5h475q12.75 0 21.38 8.62Q800-822.75 800-810v410q0 23.64-18 41.82T740-340h-34l-60-60h94v-94H552l-60-60h248v-226h-56v141q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-141h-71v55q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM437-80q-24 0-42-17.63-18-17.62-18-42.37v-200H220q-24 0-42-18t-18-42v-314.03L82-792q-9-9.07-8.5-21.53Q74-826 83.05-835q9.06-9 21.5-9 12.45 0 21.45 9l709 710q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q801-74 792-83L583-291v151q0 24.75-18 42.37Q547-80 523-80h-86ZM220-400h254l-94-94H220v94Zm0-154h100L220-654v100Zm254 154H220h254Zm172 0h94-94Z"
		/>
	</svg>
);
